import React from 'react'
import { DsButtonBase, DsImage, DsStack } from '@am92/react-design-system'

import SectionInfo from '~/src/Components/SectionInfo'

import { T_LANDING_PAGE_CONSTANTS } from '../Landing.PageConstants/TYPES'

import { APP_ANDROID_URL } from '~/src/Configurations/env'

import GOOGLE_PLAY_ICON from '~/src/Assets/ICONS/GOOGLE_PLAY_ICON'

interface IDownloadSectionProps {
  PAGE_CONSTANTS: T_LANDING_PAGE_CONSTANTS
}

const DownloadSection: React.FC<IDownloadSectionProps> = props => {
  const { PAGE_CONSTANTS } = props

  const handleDownloadAdroidClick = () => {
    window.open(APP_ANDROID_URL, '_blank')
  }

  return (
    <DsStack
      direction='column'
      alignItems='center'
      spacing={{
        xs: 'var(--ds-spacing-mild)',
        md: 'var(--ds-spacing-hot)'
      }}
      sx={{
        py: {
          xs: 'var(--ds-spacing-hot)',
          md: 'var(--ds-spacing-hot)'
        },
        px: {
          xs: 'var(--ds-spacing-bitterCold)',
          md: 'var(--ds-spacing-hot)'
        }
      }}
    >
      <SectionInfo
        title={PAGE_CONSTANTS.DOWNLOAD_TITLE}
        description={PAGE_CONSTANTS.DOWNLOAD_DESCRIPTION}
      />

      <DsButtonBase
        onClick={handleDownloadAdroidClick}
        sx={{
          width: {
            xs: '120px',
            md: '160px'
          },
          borderRadius: '6px'
        }}
      >
        <DsImage
          srcSet={GOOGLE_PLAY_ICON}
          aspectRatio={3 / 1}
          style={{ width: '100%' }}
        />
      </DsButtonBase>
    </DsStack>
  )
}

export default DownloadSection
